export const rationColumns = [
  {
    dataIndex:'rawName',
    title: '原料名称',
    ellipsis: true,
    width: 160
  },
  {
    dataIndex:'rawCode',
    title: '原料代码',
    ellipsis: true,
    width: 100
  },
  {
    dataIndex:'price',
    title: '价格',
    ellipsis: true,
    scopedSlots: {customRender: 'price'},
    width: 100,
  },
  {
    dataIndex:'uasge',
    title: '重量',
    ellipsis: true,
    scopedSlots: {customRender: 'uasge'},
    width: 100,
  },
  {
    dataIndex:'percentage',
    title: '用量(%)',
    ellipsis: true,
    scopedSlots: {customRender: 'percentage'},
    width: 100,
  },
  // {
  //   title: '用量(批次量)',
  //   dataIndex: 'uasge',
  //   scopedSlots: {customRender: 'uasge'},
  //   width: 80,
  //   ellipsis: true,
  // },
  {
    dataIndex:'minValue',
    title: '最小值',
    ellipsis: true,
    scopedSlots: {customRender: 'minValue'},
    width: 100,
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    ellipsis: true,
    scopedSlots: {customRender: 'maxValue'},
    width: 100,
  },
  {
    dataIndex:'minShadowPrice',
    title:'影子价格下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minShadowPrice'},
    width:120
  },
  {
    dataIndex:'maxShadowPrice',
    title:'影子价格上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxShadowPrice'},
    width:120
  },
  {
    dataIndex:'cost',
    title:'单位成本',
    ellipsis: true,
    scopedSlots: {customRender: 'cost'},
    width:90
  },
  {
    dataIndex:'minApply',
    title:'适用下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minApply'},
    width:100
  },
  {
    dataIndex:'maxApply',
    title:'适用上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxApply'},
    width:100
  },
]

export const supplementColumns = [
  {
    dataIndex:'rawName',
    title: '原料名称',
    width: 160,
    ellipsis: true,
  },
  {
    dataIndex:'rawCode',
    title: '原料代码',
    ellipsis: true,
    width: 100
  },
  {
    dataIndex:'price',
    title: '价格',
    ellipsis: true,
    scopedSlots: {customRender: 'price'},
    width:100
  },
  {
    dataIndex:'weight',
    title: '重量',
    ellipsis: true,
    scopedSlots: {customRender: 'weight'},
    width:100
  },
  {
    dataIndex:'mixPercentage',
    title: '用量(%)',
    ellipsis: true,
    scopedSlots: {customRender: 'mixPercentage'},
    width:100
  },
  {
    dataIndex:'percentage',
    title: '按补充料(%)',
    ellipsis: true,
    scopedSlots: {customRender: 'percentage'},
    width:100
  },
  {
    dataIndex:'uasge',
    title: '实际重量',
    ellipsis: true,
    scopedSlots: {customRender: 'uasge'},
    width:100
  },
  // {
  //   dataIndex:'productRawPercentage',
  //   title: '产品(%)',
  //   ellipsis: true,
  //   width:100
  // },
  {
    dataIndex:'minValue',
    title: '最小值',
    ellipsis: true,
    scopedSlots: {customRender: 'minValue'},
    width:100
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    ellipsis: true,
    scopedSlots: {customRender: 'maxValue'},
    width:100
  },
  {
    dataIndex:'minShadowPrice',
    title:'影子价格下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minShadowPrice'},
    width:120
  },
  {
    dataIndex:'maxShadowPrice',
    title:'影子价格上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxShadowPrice'},
    width:120
  },
  {
    dataIndex:'cost',
    title:'单位成本',
    ellipsis: true,
    scopedSlots: {customRender: 'cost'},
    width:90
  },
 
  {
    dataIndex:'minApply',
    title:'适用下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minApply'},
    width:100
  },
  {
    dataIndex:'maxApply',
    title:'适用上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxApply'},
    width:100
  },
  {
    dataIndex:'minLimitValue',
    title: '极下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minLimitValue'},
    width:100
  },
   {
    dataIndex:'maxLimitValue',
    title:'极上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxLimitValue'},
    width:100
  },
]


export const totalColumns = [
  {
    dataIndex:'nutritionName',
    title:'指标名称',
    ellipsis: true,
    width: 160,
  },
  {
    dataIndex:'unit',
    title:'单位',
    ellipsis: true,
    width: 60,
  },
  {
    dataIndex:'content',
    title:'数值',
    ellipsis: true,
    width: 100,
    scopedSlots: {customRender: 'content'},
  },
  {
    dataIndex:'minValue',
    title: '最小值',
    align:'center',
    width:100,
    scopedSlots: {customRender: 'minValue'},
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    ellipsis: true,
    width:100,
    scopedSlots: {customRender: 'maxValue'},
  },
  {
    dataIndex:'cost',
    title:'单位成本',
    ellipsis: true,
    width: 100,
    scopedSlots: {customRender: 'cost'},
  },
  {
    dataIndex:'minApply',
    title:'适用下限',
    ellipsis: true,
    width: 100,
    scopedSlots: {customRender: 'minApply'},
  },
  {
    dataIndex:'maxApply',
    title:'适用上限',
    ellipsis: true,
    width:  100,
    scopedSlots: {customRender: 'maxApply'},
  },
  {
    dataIndex:'minLimitValue',
    title: '极下限',
    ellipsis: true,
    width:  100,
    scopedSlots: {customRender: 'minLimitValue'},
  },
  {
    dataIndex:'maxLimitValue',
    title:'极上限',
    ellipsis: true,
    width:  100,
    scopedSlots: {customRender: 'maxLimitValue'},
  },
]
export const nutritionSupplementColumns = [
  {
    dataIndex:'nutritionName',
    title:'指标名称',
    ellipsis: true,
    width: 160,
  },
  {
    dataIndex:'unit',
    title:'单位',
    ellipsis: true,
    width: 60,
  },
  {
    dataIndex:'content',
    title:'数值',
    ellipsis: true,
    width: 100,
    scopedSlots: {customRender: 'content'},
  },
  // {
  //   dataIndex:'productContent',
  //   title: '产品',
  //   ellipsis: true,
  //   width:100,
  //   scopedSlots: {customRender: 'productContent'},
  // },
  {
    dataIndex:'minValue',
    title: '最小值',
    ellipsis: true,
    width:100,
    scopedSlots: {customRender: 'minValue'},
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    ellipsis: true,
    width:100,
    scopedSlots: {customRender: 'maxValue'},
  },
  {
    dataIndex:'cost',
    title:'单位成本',
    ellipsis: true,
    width: 100,
    scopedSlots: {customRender: 'cost'},
  },
  {
    dataIndex:'minApply',
    title:'适用下限',
    ellipsis: true,
    width: 100,
    scopedSlots: {customRender: 'minApply'},
  },
  {
    dataIndex:'maxApply',
    title:'适用上限',
    ellipsis: true,
    width:  100,
    scopedSlots: {customRender: 'maxApply'},
  },
  {
    dataIndex:'minLimitValue',
    title: '极下限',
    ellipsis: true,
    width:  100,
    scopedSlots: {customRender: 'minLimitValue'},
  },
  {
    dataIndex:'maxLimitValue',
    title:'极上限',
    ellipsis: true,
    width:  100,
    scopedSlots: {customRender: 'maxLimitValue'},
  },
]